import React, { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import responsiveStyles from './responsiveStyles.module.scss'

import FloatingInfoBox from '../../reusable/FloatingInfoBox'
import { ContactDetails, Person, Address, Review } from '../../formParts'
import { SaveValueInterface } from '../../../interfaces'
import { fieldValidation, uploadDataToServer } from '../../../helpers'
import { useUpdateClaimData } from '../../../claimProvider'
import { SignatureSentinel } from '../../formParts/signatureSentinel'
import NewsBanner from '../../newsBanner'
import EligibilitySection from '../../EligibilitySection'
import { ft, gbn, itv, skyNews, theSun, bbc, dm } from '../../../assets/newsOutlets'
import { OpenBankingStep } from '../../formParts/openBanking'
const newsItems = [
    {
        id: 1,
        // companyName: 'ITV',
        image: itv,
    },
    {
        id: 2,
        // headline: 'As seen on BBC News',
        // companyName: 'BBC News',
        image: bbc,
    },
    {
        id: 3,
        // companyName: 'Sky News',
        image: skyNews,
    },
    {
        id: 4,
        // headline: 'As seen in the Financial Times',
        // companyName: 'Financial Times',
        image: ft,
    },
    {
        id: 5,
        // companyName: 'Daily Mail',
        image: dm,
    },
    {
        id: 6,
        // headline: 'As seen in the Sun',
        // companyName: 'The Sun',
        image: theSun,
    },
    {
        id: 7,
        // companyName: 'GB News',
        image: gbn,
    },
]

const steps = [
    {
        text: 'Your Details',
        transitionPoint: 0,
        step: 1,
    },
    {
        text: 'Review & Sign',
        transitionPoint: 2,
        step: 2,
    },
    {
        text: 'Complete Application',
        transitionPoint: 4,
        step: 3,
    },
]

const LEAD_SOURCE = window.location.href
const LEAD_ORIGIN = 'webform_MBFINANCECHECK'
function ClaimFormMbFinanceCheck() {
    const [claimObject, setClaimObject] = useState<any>({
        leadOrigin: LEAD_ORIGIN,
        leadSource: LEAD_SOURCE,
    })
    const [groupsComplete, setGroupsComplete] = useState(0)
    const [activeGroup, setActiveGroup] = useState('address')
    const [displayedPercentage, setDisplayedPercentage] = useState(0)
    const [actualPercentage, setActualPercentage] = useState(0)
    const [showInfoBox, setShowInfoBox] = useState(true)
    const updateClaim = useUpdateClaimData()

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => e.preventDefault()

    const saveFieldValue = (dataToSave: SaveValueInterface) => {
        console.log(dataToSave)
        let tempClaimObject = claimObject

        if (tempClaimObject) {
            tempClaimObject[dataToSave.field] = dataToSave.value
        }

        setClaimObject(tempClaimObject)
        // console.log("CLAIM OBJECT: ", claimObject);

        const validated = fieldValidation(dataToSave)

        if (validated.success) {
            return validated
        } else {
            return validated
        }
    }

    const activeGroupAssignment = async (group: string) => {
        console.log('next group to display: ', group)
        console.log('CLAIM OBEJECT : ', claimObject)

        let newGroupsComplete = groupsComplete

        const flowOrder = ['address', 'person', 'contact', 'review', 'signature', 'complete']
        const currentIndex = flowOrder.indexOf(activeGroup)
        const nextIndex = flowOrder.indexOf(group)

        if (nextIndex > currentIndex) {
            newGroupsComplete = nextIndex
        }

        if (activeGroup === 'address' && nextIndex > currentIndex) {
            setShowInfoBox(false)
        }

        setActiveGroup(group)

        if (group === 'review' || group === 'signature') {
            if (group === 'signature') {
                try {
                    const claimData = await uploadDataToServer(claimObject)
                    updateClaim({
                        ...claimData.claimData,
                        leadOrigin: LEAD_ORIGIN,
                        leadSource: LEAD_SOURCE,
                    })
                } catch (error) {
                    console.error('Error uploading data before signature:', error)
                }
            } else {
                updateClaim({
                    ...claimObject,
                    leadOrigin: LEAD_ORIGIN,
                    leadSource: LEAD_SOURCE,
                })
            }
        }

        window.scrollTo(0, 0)
        setGroupsComplete(newGroupsComplete)
    }

    useEffect(() => {
        // Calculate percentage based on the total number of steps
        // flowOrder has 6 steps, so each step is worth 100/5 = 20% (we subtract 1 because we start at 0%)
        const totalSteps = 5 // Total number of transitions in the flow
        const newPercentage = Math.min(Math.round((groupsComplete / totalSteps) * 100), 100)
        setActualPercentage(newPercentage)
    }, [groupsComplete])

    useEffect(() => {
        if (displayedPercentage === actualPercentage) return

        const isCountingUp = displayedPercentage < actualPercentage

        const animationInterval = setInterval(() => {
            setDisplayedPercentage((prev) => {
                if (isCountingUp) {
                    return prev < actualPercentage ? prev + 1 : actualPercentage
                } else {
                    return prev > actualPercentage ? prev - 1 : actualPercentage
                }
            })
        }, 20)

        return () => clearInterval(animationInterval)
    }, [actualPercentage, displayedPercentage])

    return (
        <div>
            <FloatingInfoBox
                position="right"
                showBox={showInfoBox}
                message={
                    <>
                        Quick & easy
                        <br />
                        Just 60 seconds!
                    </>
                }
            />

            <div className={`${styles.formContainer} ${responsiveStyles.formContainer}`}>
                <div className={`${styles.formTitle} ${responsiveStyles.formTitle}`}>
                    {groupsComplete > 4 || activeGroup === 'openBanking' ? (
                        <h1>
                            Great news <br /> your PCP claim review is underway.
                        </h1>
                    ) : (
                        <h1>
                            Register <span className={styles.highlight}>YOUR</span> <br />
                            Mis-sold Vehicle Finance Claim
                        </h1>
                    )}

                    {activeGroup !== 'openBanking' && (
                        <div
                            className={`${styles.percentageProgressContainer} ${responsiveStyles.percentageProgressContainer}`}
                        >
                            <div className={styles.percentageProgressBar}>
                                <div
                                    className={styles.percentageProgressFill}
                                    style={{
                                        width: `${displayedPercentage}%`,
                                    }}
                                />
                            </div>
                            <div
                                className={styles.percentageProgressText}
                                style={{
                                    left: `${Math.min(Math.max(displayedPercentage, 10), 90)}%`,
                                }}
                            >
                                {displayedPercentage}%
                            </div>
                        </div>
                    )}
                </div>
                <form className={`${styles.form}`} onSubmit={(e) => handleSubmit(e)}>
                    <div className={styles.formFields}>
                        <Address
                            saveValueFunct={saveFieldValue}
                            isActive={activeGroup}
                            assignGroup={activeGroupAssignment}
                        />
                        <Person
                            saveValueFunct={saveFieldValue}
                            isActive={activeGroup}
                            assignGroup={activeGroupAssignment}
                        />
                        <ContactDetails
                            saveValueFunct={saveFieldValue}
                            isActive={activeGroup}
                            assignGroup={activeGroupAssignment}
                        />
                        <Review
                            saveValueFunct={saveFieldValue}
                            isActive={activeGroup}
                            assignGroup={activeGroupAssignment}
                        />
                        <SignatureSentinel
                            saveValueFunct={saveFieldValue}
                            isActive={activeGroup}
                            assignGroup={activeGroupAssignment}
                        />
                        <OpenBankingStep
                            isActive={activeGroup}
                            saveValueFunct={saveFieldValue}
                            assignGroup={activeGroupAssignment}
                        />
                        {/* <Complete
                            isActive={activeGroup}
                            saveValueFunct={saveFieldValue}
                            assignGroup={activeGroupAssignment}
                        /> */}
                    </div>
                </form>
            </div>
            <div className={styles.socialProofStrip}>
                <span className={styles.socialProofLabel}>As seen on</span>
                <NewsBanner items={newsItems} speed="fast" height={60} backgroundColor="transparent" textColor="#555" />
            </div>

            <div className={styles.eligibilitySectionWrapper}>
                <EligibilitySection />
            </div>

            <div className={styles.dualVideoContainer}>
                <h3 className={styles.dualVideoTitle}>Watch Sentinel Legal discuss mis-sold vehicle finance</h3>
                <div className={styles.videoGrid}>
                    <div className={styles.videoSection}>
                        <div className={styles.videoTitle}>
                            <span>Sentinel Legal on</span>
                            <img src={skyNews} alt="Sky News" className={styles.newsLogo} />
                        </div>
                        <div className={styles.videoWrapper}>
                            <iframe
                                width="100%"
                                height="100%"
                                src="https://www.youtube.com/embed/vzQ8qgvxV0U"
                                title="Sentinel Legal on Sky News"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            />
                        </div>
                    </div>
                    <div className={styles.videoSection}>
                        <div className={styles.videoTitle}>
                            <span>Sentinel Legal on</span>
                            <img src={gbn} alt="GB News" className={styles.newsLogo} />
                        </div>
                        <div className={styles.videoWrapper}>
                            <iframe
                                width="100%"
                                height="100%"
                                src="https://www.youtube.com/embed/DzSiw4xWm78"
                                title="Sentinel Legal on GB News"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* <div
                style={{
                    marginTop: 40,
                    marginBottom: 40,
                    padding: '40px 0',
                    backgroundColor: 'transparent',
                    background: 'transparent',
                }}
            >
                <h3 style={{ textAlign: 'center', marginBottom: 30, color: '#333' }}>What Our Customers Say</h3>
                <div className={styles.testimonialSection}>
                    <Testimonials />
                </div>
            </div> */}
        </div>
    )
}

export default ClaimFormMbFinanceCheck
